<template>
    <div>
            <CustomDialog ref='visiondialog' :element='devDialog.element' :styles='devDialog.styles' >
                <template v-slot:dialog-content>
                    <version-task ref="vertask" @close='cancel' :showToast='showToast'></version-task>
                </template>
            </CustomDialog>
            <CustomDialog ref='detaildialog' :element='detDialog.element' :styles='detDialog.styles' >
                <template v-slot:dialog-content>
                    <detail-list ref="detaillist" @close='detailCancel'></detail-list>
                </template>
            </CustomDialog>
            <div class='h-toolbarBg'>
                <ejs-toolbar>
                    <e-items>
                        <e-item  prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Software.addtask")' :click='click' ></e-item>
                        <e-item  prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Software.delete")' :click='remove' ></e-item>
                        <e-item  prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Alarm.exportAll")' :click='exportLog' ></e-item>
                    </e-items>
                </ejs-toolbar>
                <div class='h-inputBox'>
                    <ejs-textbox  :placeholder='$t("Software.keySerach")' @keydown.enter.native="search" v-model='input' />
                </div>
            </div>
            <div>
                <ejs-treegrid ref='grid' :dataSource='data' childMapping="subtasks" :allowResizing='true'
                    :rowDataBound="rowDataBound" autoCheckHierarchy="true" collapsed="true" :recordDoubleClick='handleClick' height='calc(100vh - 236px)'>
                    <e-columns>
                        <e-column field='netCode' :headerText='$t("Software.td_neID")' width='10%' showCheckbox="true" clipMode='EllipsisWithTooltip'></e-column>
                        <!--<e-column field='netType' :headerText='$t("Software.td_neName")' width='8%' clipMode='EllipsisWithTooltip'></e-column>-->
                        <e-column field='operType' :headerText='$t("Software.td_operationType")' width='10%' :valueAccessor='operTypeFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <!-- <e-column field='taskType' :headerText='$t("Software.td_taskType")' width='8%' :valueAccessor='taskTypeFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        -->
                        <e-column field='fileName' :headerText='$t("Software.td_fileName")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='progress' :headerText='$t("Software.td_progress")' width='15%' :template='cTemplate' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='status' :headerText='$t("Software.td_status")' width='8%' :valueAccessor='statusFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='result' :headerText='$t("Software.td_result")' width='7%' :valueAccessor='resultFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='createTime' :headerText='$t("Software.td_createTime")' width='11%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='scheduledtime' :headerText='$t("Software.td_executionTime")' width='11%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='finishTime' :headerText='$t("Software.td_finishTime")' width='11%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='detail' :headerText='$t("Software.td_detail")' width='17%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='taskId' :isPrimaryKey='true' :visible='false' ></e-column>
                    </e-columns>
                </ejs-treegrid>
                <ejs-pager ref='pagerUpdate' @click='request' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
            </div>
    </div>
</template>

<script>
import Vue from "vue";
import BasicLayout from '../../layouts/BasicLayout';
import { TreeGridPlugin, Page, Resize } from "@syncfusion/ej2-vue-treegrid";
import Progress from '../../components/software/ProgressTemplate'
import CustomDialog from '../../components/common/CustomDialog';
import VersionTask from '../../components/software/VersionTask';
import socketInstance from '../../plugins/stompSock';
import detail from '../../components/software/DetailTemplate';
import DetailList from '../../components/software/DetailList';

import { EventBus } from '../../plugins/eventBus';

Vue.use(TreeGridPlugin);
let dataSource = [];
export default {
    name: 'version-update',
    components:{
        BasicLayout,
        Progress,
        CustomDialog,
        VersionTask,
        DetailList
    },
    data() {
        return{
            left: { show: false, name: '' },
            middle: { show: false, name: '' },
            right: { show: true, crumb: this.$t('Software.softManage_Upd')},
            devDialog: {
                element: {
                    target: '#app',
                    isClose: true,
                    title: this.$t('Software.lte_udp_version'),
                    refName: this.$t('Software.updManage'),
                    buttonGroup: [
                        { click: this.cancel, buttonModel: { content: this.$t('MCS.cancle') } },
                        { click: this.submit, buttonModel: { content: this.$t('System.confirm'), isPrimary: true } },
                    ]
                },
                styles: {
                    width: "65%",
                    height: "80%",
                    visible: false,
                    model: true,
                    zIndex: 1001

                },
            },
            detDialog: {
                element: {
                    target: '#app',
                    isClose: true,
                    title: this.$t('Software.downloadtasklist'),

                    refName: '',
                    buttonGroup: [,
                        { click: this.cancel, buttonModel: { content: this.$t('MCS.cancle') } }
                    ]
                },
                styles: {
                    width: '800px',
                    height: '695px',
                    visible: false,
                    model: true
                },
            },
            data: [],
            page: {
                pageNo: 1,
                pageSize: 15,
                totalCount: 0,
                pageCount: 4
            },
            cTemplate: function(args) {
                return { template: Progress }
            },
            detailTemplate: function(args){
                return { template: detail }
            },
            pageSettings: { pageSizes: true, pageCount: 4, pageSize: 20 },
            input: '',
            taskmap: new Map().set(0,this.$t('Software.netask')).set(1,this.$t('Software.opetask')),
            opermap: new Map(
                [
                    [0,this.$t('Software.download')],
                    [1,this.$t('Software.active')],
                    [2,this.$t('Software.DlandAt')],
                    [3,this.$t('Software.rollback')],
                    [4,this.$t('Software.upload')],
                    [5,this.$t('Software.DlandUl')],
                    [6,this.$t('Software.AtandUl')],
                    [7,this.$t('Software.DlandAtandUl')],
                    [8,this.$t('Software.RbandUl')]
                ]),
            statusmap: new Map(
                [
                    [0,this.$t('Software.notstart')],
                    [1,this.$t('Software.waitforexe')],
                    [2,this.$t('Software.progressing')],
                    [3,this.$t('Software.done')],
                    [4,this.$t('Software.downloading')],
                ]),
            resultmap: new Map(
                [
                    [0,this.$t('Software.success')],
                    [1,this.$t('Software.fail')],
                    [2,this.$t('Software.partSucc')],
                ]),
            payload: [
                { topic: '/topic/VmUpdateWsServer', clientId: '', callback: this.subscribeCallback }
            ],
        }
    },
    provide: {
      treegrid: [ Page, Resize],
    },
    mounted() {
        this.request();

        // this.webSoketRequest11 = setInterval(() => {
        //      this.webSoketRequest();
        //    }, 5000);
        socketInstance.init(this.payload);//与查询版本重冲突
    },
    beforeDestroy() {
        for (let i = 0; i < this.payload.length; i++) {
            socketInstance.stopReceiveTopicMsg(this.payload[i].clientId, this.payload[i].topic);
        }//与查询版本重冲突
    },
    methods: {
        levelFormat(grids, data) {
            if(data.result === 0){
                return `<span @click="handleClick" class='h-alarmLevel3'>
                            ${data.detail}
                        </span>`
            }
            else {
                return `<div e-toolbar-items>
                            <span>
                                ${data.detail}
                            </span>
                        </div>`;
            }
        },
        request() {
            let para={
                neName: '',
                taskstatus: '',
                taskresult: '',
                systemId:'1',
            };
            let page={
                    pageNo: this.$refs.pagerUpdate.ej2Instances.currentPage,
                    pageSize: this.$refs.pagerUpdate.ej2Instances.pageSize,
            };
            this.axios.post(`/lte/ems/verupdate_new/queryUpdateTask?pageNo=${page.pageNo}&pageSize=${page.pageSize}&neName=${this.input}`).then((response) => {
                if(response.data.errorCode == 'SUCCESS'){
                    dataSource = response.data.resultVal.result;
                    this.page.totalCount = response.data.resultVal.totalCount;
                    this.page.pageNo = response.data.resultVal.pageNo;
                    this.page.pageSize = response.data.resultVal.pageSize,
                    this.page.pageCount = response.data.resultVal.totalPages === 0 ? 1: response.data.resultVal.totalPages;
                    this.dataBinding(dataSource);
                }
            });
        },
        webSoketRequest()
        {
            const that =this;
            let para={
                neName: '',
                taskstatus: '',
                taskresult: '',
                systemId:'1',
            };
            let page={
                    pageNo: that.$refs.pagerUpdate.ej2Instances.currentPage,
                    pageSize: that.$refs.pagerUpdate.ej2Instances.pageSize,
            };
            that.axios.post(`/lte/ems/verupdate_new/queryUpdateTask?pageNo=${page.pageNo}&pageSize=${page.pageSize}&neName=${that.input}`).then((response) => {
                if(response.data.errorCode == 'SUCCESS'){
                    if(that.data.length !== response.data.resultVal.totalCount)
                    {
                        console.log('request');
                        that.request();
                        return;
                    }
                    dataSource = response.data.resultVal.result;
                    let newdata = JSON.parse(JSON.stringify(that.data));
                    newdata.forEach(item => {
                        dataSource.forEach(element =>{
                            if(item.taskId == element.taskId)
                            {
                                that.$refs.grid.setCellValue(item.taskId, 'status',element.status);
                                that.$refs.grid.setCellValue(item.taskId, 'progress',element.progress);
                                that.$refs.grid.setCellValue(item.taskId, 'result',element.result);
                                that.$refs.grid.setCellValue(item.taskId, 'scheduledtime',element.scheduledtime);
                                that.$refs.grid.setCellValue(item.taskId, 'detail',element.detail);
                            }
                            else if(item.taskId == element._parentId)
                            {
                                item.subtasks.forEach(model => {
                                    if(model.taskId == element.taskId)
                                    {
                                        that.$refs.grid.setCellValue(model.taskId, 'status',element.status);
                                        that.$refs.grid.setCellValue(model.taskId, 'progress',element.progress);
                                        that.$refs.grid.setCellValue(model.taskId, 'result',element.result);
                                        that.$refs.grid.setCellValue(model.taskId, 'scheduledtime',element.scheduledtime);
                                        that.$refs.grid.setCellValue(model.taskId, 'detail',element.detail);
                                    }
                                })
                            }
                        })
                    })
                }
            });
        },
        dataBinding(dataSource) {
            let resdata = [];
            dataSource.forEach(element => {
                if(element._parentId == null) {
                    let master = {};
                    master.taskId = element.taskId;
                    master.netCode = element.netCode;
                    master.netType = element.netType;
                    master.taskType = element.taskType;
                    master.operType = element.operType;
                    if(element.operType ==7){
                        master.operType = 2;
                    }
					          if(element.operType ==6){
                        master.operType = 1;
                    }
                    master.fileName = element.fileName;
                    master.status = element.status;
                    master.progress = element.progress;
                    master.result = element.result;
                    master.createTime = element.createTime;
                    master.scheduledtime = element.scheduledtime;
                    master.detail = element.detail;
                    master.neId = element.neId;
                    master.finishTime = element.finishTime;
                    master.subtasks = [];
                    if(element.operType != 4){
                       resdata.push(master);
                    }

                }
                else{
                    let hasCont = false;
                    resdata.forEach(item => {
                        if(item.taskId == element._parentId) {
                            hasCont = true;
                             if(element.operType != 4){
                                 item.subtasks.push(element);
                              }

                        }
                    })
                    //子数据存在而无父数据时列表展示（主要用于模糊搜索中的所有子任务的场景）
                    if(!hasCont)
                    {
                        if(element.operType != 4){
                           resdata.push(element);
                        }

                    }
                }
            });
            this.data = resdata;
        },

        taskTypeFormatter(field, data, column) {
            return this.taskmap.get(data['taskType']);
        },
        operTypeFormatter(field, data, column){
            return this.opermap.get(data['operType']);
        },
        statusFormatter(field, data, column){
            if(data['_parentId'] != undefined)
            {
                //根据子节点的状态还设置父节点的状态
                this.data.forEach(item => {
                    if(item.taskId === data['taskId'])
                    {
                        if(data['status'] > 2 && item.status < 2)
                        {
                            item.status = 2;
                        }
                    }
                })
            }
            return this.statusmap.get(data['status']);
        },
        resultFormatter(field, data, column){
            return this.resultmap.get(data['result']);
        },
        click(){
            EventBus.$emit('visiondialogOpen');
            this.$refs.visiondialog.show();
            this.$refs.vertask._getNeTreeData();
        },
        search(args) {
            if(this.input !== '')
            {
                const filterdata = dataSource.filter(item => this.filterMethod(item)).map(
                    item => {return item}
                );
                this.dataBinding(filterdata);
            }
            else{
                this.dataBinding(dataSource);
            }
            // this.request();
        },
        //过滤方法
        filterMethod(item){
            const colmap = new Map([
                ['taskType', this.taskmap],
                ['operType', this.opermap],
                ['status', this.statusmap],
                ['result', this.resultmap],
            ])
            const colarray = ['netCode', 'netType','fileName', 'progress', 'createTime', 'scheduledtime', 'detail'];
            let feildData1 = Array.from(colarray, x => {
                return item[x] === null ? '' : item[x] +'';
            });
            let feildData2 = Array.from([...colmap.keys()], x =>{
                var mapvalue = colmap.get(x).get(item[x]);
                return mapvalue === undefined ? '' : mapvalue;
            });
            let filres = false;
            [...feildData1, ...feildData2].forEach(item => {
                if(item.indexOf(this.input) > -1)
                {
                    filres = true;
                }
            })
            return filres;
        },
        submit(clickEvent) {
            if (clickEvent.keyCode === 13) {
                return;
            }
            this.$refs.vertask.updateVersion(() => {
                    this.cancel();
                    this.request();
                });
        },
        cancel() {
            this.$refs.visiondialog.clear();
            this.$refs.visiondialog.close();
        },
        subscribeCallback(myData) {
            console.log('callback',myData)
            this.input = '';
            this.webSoketRequest();
        },
        getSelect() {
            const select = [];
            this.$refs.grid.getCheckedRecords().forEach(item => {
                if(item.level == 0)
                {
                    select.push(item);
                }
            })
            return select;
        },
        exportLog(){
        this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
          axios({
                    method: 'post',
                    url: '/lte/ems/verupdate_new/exportUpGradeLog',
                    data:{data:1},
                    // 二进制流文件，一定要设置成blob，默认是json
                    responseType: 'blob'
                  }).then(response => {
                    this.$loading.hideLoadding();
                    const link = document.createElement('a');
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
                    let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

                    link.style.display = 'none';
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", regFileNames);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                     this.$loading.hideLoadding();
                  });
        },
        remove() {
            const taskIds = this.getSelect().map(x => x.taskId +'');
            if(taskIds.length == 0)
            {
                this.showToast('warning',`${this.$t("System.selectDelObj")}`);
                return;
            }
            this.$layer.confirm({
                msg: this.$t('LteUser.delConfirm'),
                btn2: {
                    msg: this.$t('System.confirm'),
                    func: () => {
                        this.$axios.post('/lte/ems/verupdate_new/delVerAction', taskIds).then((response) => {
                            if(response.status == 200)
                            {
                                if(response.data.errorCode == 'SUCCESS')
                                {
                                    this.showToast('success', `${this.$t('Common.tips.success')}`);
                                }
                                else
                                {
                                    this.showToast('error',response.data.errorString);
                                }
                            }
                            this.request();
                        });
                    }
                },
                btn1: {
                    msg: this.$t('MCS.cancle')
                }
            });

        },
        redo() {

            const taskIds = this.getSelect().map(x => x.taskId +'');
            if(taskIds.length == 0)
            {
                this.showToast('warning',`${this.$t("Software.selectOprObj")}`);
                return;
            }

            const select = this.getSelect().filter(x => x.status == '2');
            if(select.length != 0)
            {
                this.showToast('warning',`${this.$t("Software.messionExist")}`);
                return;
            }

            this.$axios.post('/lte/ems/verupdate_new/reStartAction', taskIds).then((response) => {
                if(response.status == 200)
                {
                    if(response.data.errorCode == 'SUCCESS')
                    {
                        this.showToast('success', `${this.$t('Common.tips.success')}`);
                        // this.$layer.success();
                    }
                    else
                    {
                        this.showToast('error',response.data.errorString);
                    }
                }
                else{
                    this.showToast('error', `${this.$t('Common.tips.failure')}`);
                }
                this.request();
            });
        },
        rowDataBound(args){
            if(args.data['level'] === 1){
              args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('h-system-disablecheckbox')
            }
        },

        handleClick(args) {
            if(args.cellIndex === 9)
            {
                console.log('handleClick',args)
                if(args.rowData.result == 0)
                {
                    console.log('args.rowData.taskId',args.rowData.taskId)
                    this.$refs.detaildialog.show();
                    this.$refs.detaillist.queryMethod(args.rowData.taskId);
                }
            }
        },
        detail(taskId) {
            console.log('notice')
        },
        detailCancel() {
            this.$refs.detaillist.clear();
            this.$refs.detaillist.close();
        },
        showToast(type, content)
        {
            // this.$parent.showToast(type,content);
            EventBus.$emit('toast', {type: type, content: content});

        }
    }
}
</script>>
